import styled, { css } from 'styled-components';
import { Button } from 'components';

export const AdOverlayStyled = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  bottom: 90px;
  cursor: pointer;
  ${(props) => {
    if (props.position === 'left') {
      return css`
        left: 0;
        right: auto;
        transform: none;
      `;
    } else if (props.position === 'right') {
      return css`
        right: 0;
        left: auto;
        transform: none;
      `;
    }

    return false;
  }};
  ${(props) =>
    props.hiddenSkin &&
    css`
      bottom: 10px;
    `};
  iframe,
  img {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const CloseButton = styled(Button)`
  && {
    position: absolute;
    padding: 8px;
    top: 5px;
    right: 5px;
    transition: all 0.25s ease;
  }
`;

export const Content = styled.div`
  position: relative;
`;
